// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../order-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StripeElement{border:1px solid #ced4da;height:calc(1.5em + 1.5rem + 2px);border-radius:.25rem;color:#495057;padding:.75rem .75rem}.StripeElement--focus{border-color:#003c71!important;box-shadow:0 0 0 .2rem rgba(12,76,133,.6)!important;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out!important}", ""]);
// Exports
module.exports = exports;
